module.exports = __webpack_public_path__ + "img/__rocket01.53eaa36e.svg";